import React from 'react';
import { getTeacherQualification } from 'helpers/playerData';
import type { PlayerDetailType } from 'types/player';
import type { UserDetailType } from 'types/user';
import AdKaoraBanner, { AdSlot } from './AdKaoraBanner';
import Banner from './Banner';
import BaseStatistics from './BaseStatistics';
import CompetitionObject from './CompetitionObject';
import Container from './Container';
import HarmonizedRankBox from './HarmonizedRankBox';
import MatchCarousel from './MatchCarousel';
import PlayerBasicInfo from './PlayerBasicInfo';
import PlayerBio from './PlayerBio';
import PlayerCharacteristics from './PlayerCharacteristics';
import PlayerEndorsements from './PlayerEndorsements';
import ProfessionalInfos from './ProfessionalInfos';
import RankBox from './RankBox';
import SuperSimulationRankBox from './SuperSimulationRankBox';

export const PlayerDetails: React.FC<{
  loading: boolean;
  player?: PlayerDetailType;
  user?: UserDetailType;
}> = ({ loading, player, user }) => (
  <div id='content' className='mt-2 flex flex-col gap-2 lg:flex-row'>
    <div className='min-w-0 overflow-hidden lg:min-w-80 lg:basis-1/4'>
      <PlayerBasicInfo loading={loading} {...player} {...user} userProfile={false} />
    </div>
    <div className='min-w-0 overflow-hidden lg:basis-3/4'>
      <AdKaoraBanner slot={AdSlot.ARTICLE_MIDDLE} />

      <div className='flex flex-col gap-3'>
        <BaseStatistics
          loading={loading}
          winPercentage={player?.matches.won_percentage}
          matchesWon={player?.matches.won}
          matchesLost={player?.matches.lost}
          fitpPoints={player?.info.fit_points}
        />

        <Container title='Classifica'>
          <div className='flex flex-col gap-2'>
            <RankBox playerInfo={player?.info} loading={loading} />
            <div title='Classifica' className='grid grid-cols-1 gap-2 md:grid-cols-2'>
              <SuperSimulationRankBox playerId={player?.id} isMatchesPage={false} />
              <HarmonizedRankBox currentRank={player?.info.simulated_rank} playerId={player?.id} />
            </div>
          </div>
        </Container>
        <Banner slot='TENNISTALKER_PLAYER_DETAIL' />

        <div className='flex flex-col gap-3'>
          {user?.bio && <PlayerBio bio={user.bio} />}
          {user && (
            <PlayerCharacteristics
              lefthanded={user.lefthanded}
              preferred_surface={user.preferred_surface}
              racket_brand={user.racket_brand}
              shoes_brand={user.shoes_brand}
              clothing_brand={user.clothing_brand}
              single_handed={user.single_handed}
            />
          )}
          <PlayerEndorsements playerId={player?.id} userId={player?.user_id} />

          {user?.nutritionist && (
            <ProfessionalInfos
              role='Nutrizionista'
              qualifications={user.nutritionist.qualifications}
              professional_info={user.nutritionist.professional_info}
            />
          )}

          {user?.mental_coach && (
            <ProfessionalInfos
              role='Mental Coach'
              qualifications={user.mental_coach.qualifications}
              professional_info={user.mental_coach.professional_info}
            />
          )}

          {user?.teacher && (
            <ProfessionalInfos
              role='Maestro di tennis'
              qualifications={getTeacherQualification(user.teacher.qualification)}
              professional_info={user.teacher.professional_info}
            />
          )}

          {user?.trainer && (
            <ProfessionalInfos
              role='Preparatore atletico'
              qualifications={user.trainer.qualification}
              professional_info={user.trainer.professional_info}
            />
          )}

          {user?.shop && (
            <ProfessionalInfos
              role='Shop'
              firstInfoTitle='Nome'
              qualifications={user.shop.name}
              secondInfoTitle='Sito web'
              professional_info={user.shop.website}
              thirdInfoTitle='Informazioni'
              thirdInfo={user.shop.info}
              fourthInfoTitle='Indirizzo'
              fourthInfo={user.shop.address}
            />
          )}
          <Banner slot='HEADER_TWE'></Banner>
          {player?.last_matches && player.last_matches.length > 0 && (
            <Container title='Ultime partite'>
              <MatchCarousel player={player} loading={loading} matches={player?.last_matches} />
            </Container>
          )}
          {player?.active_competitions && player.active_competitions.length > 0 && (
            <Container title='Tornei a cui partecipa'>
              <div className='flex flex-col gap-3'>
                {player.active_competitions.map((competition) => (
                  <CompetitionObject key={competition.id} {...competition} loading={loading} />
                ))}
              </div>
            </Container>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default PlayerDetails;
